<template>
	<page-content-layout class="tracker-list" title="Trackers">
		<button-view slot="tools" label="Opret" @click="createButtonClick" />
		<new-table-view ref="table" :columns="[
			{
				label: 'Label',
				name: 'label'
			},
			{
				label: 'Check-in',
				name: 'checkin',
				translation: {
					true: 'Ja',
					false: 'Nej'
				}
			},
			{
				label: 'Radius',
				name: 'dist',
				suffix: ' m',
				filter: 'integer',
				align: 'right'
			},
			{
				label: 'Hysterese',
				name: 'hyst',
				suffix: ' m',
				filter: 'integer',
				align: 'right'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				}
			}
		]" :items="items" @itemClick="itemClick" @delete="itemDelete" />
	</page-content-layout>
</template>

<script>
	import Window from '../windows/GeofenceWindow'
	import NewTableView from '../views/NewTableView'

    export default {
		props: [],
		components: { NewTableView },
		methods: {
			createButtonClick: function () {
				var self = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						
						

						self.update();
					}
				});
			},
			itemClick: function (item) {
				var self = this;

				this.$store.state.windowStack.push(Window, {id: item.id, form: true, onChange: function () {
					self.update();
				}});
			},
			itemDelete: function (item) {
				if (confirm('Sikker?')) {
					

					var self = this;

					this.axios
						.delete('/tracking/geofencing/' + item.id + '/')
						.then(function () {
							self.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				this.axios
					.get('/tracking/geofencing/')
					.then(function (r) {
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				items: [],
				actions: [
					{name: 'delete', label: 'Delete'}
				]
			};
		},
		mounted: function () {
			this.axios.put('/activity/geofencing/');

			this.update();


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		}
    }
</script>

<style lang="scss">

</style>